import styled from 'styled-components';
import Tokens from '@grnhse/seedling/lib/birch/tokens';
import { FullPalette } from '@grnhse/seedling/lib/birch/colors';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: start;
  gap: ${Tokens.spacing['0.5']};
  background-color: ${FullPalette.GREY_E500};
  border-radius: 5px;
  padding-left: ${Tokens.spacing['1']};
  padding-top: ${Tokens.spacing['0.5']};
  padding-bottom: ${Tokens.spacing['0.25']};

  button {
    padding-top: ${Tokens.spacing['0.25']};
  }
`;

export default Container;
